export default {
    setEngagementWorkingHours(state, payload) {
      state.engagementWorkingHours = payload;
    },
  };
  